<template>
    <div class="form-elements">
        <div class="row w-100" v-show="!download.load">
            <div class="col-md-12 p-0">
                <button @click="getTeoricasAgendadasHoje()" class="btn btn-dark btn-micro w-100">Gerar Planilha</button>
            </div>
        </div>
        <div v-show="download.load">
            <span>Pode demorar um pouco...</span>
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import RelatoriosController from '../RelatoriosController'

export default {
    name: 'AgendadasHoje',
    components: {
        ...spinners,
    },

    data () {
        return {
            download: {
                load: false
            },
            dataInicial: '',
            dataFinal: ''
        }
    },

    methods: {

        getTeoricasAgendadasHoje()
        {
            this.download.load = true

            RelatoriosController.getTeoricasAgendadasHoje(response => {
                if(response.sucesso === false) {
                    this.download.load = false
                } else {
                    var csv = 'data:text/csv;charset=utf-8,' + response.dados;
                    var dlnk = document.getElementById('downloadCSV');
                    dlnk.download="teoricas_agendadas_hoje.csv";
                    dlnk.href = csv;
                    dlnk.click();
                    this.download.load = false
                }
            })
        },

        launchToast(icon, msg)
        {
            this.$toasted.show(msg, {
                position: 'top-right',
                icon: icon
            });
        }

    }
}
</script>